/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Creator_CtaInputs */

const en_pricing_creator_cta = /** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Creator`)
};

const es_pricing_creator_cta = /** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertirse en Creador`)
};

const fr_pricing_creator_cta = /** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devenir Créateur`)
};

const de_pricing_creator_cta = /** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator werden`)
};

const id_pricing_creator_cta = /** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadi Kreator`)
};

/** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */
const ja_pricing_creator_cta = en_pricing_creator_cta;

/** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */
const zh_pricing_creator_cta = en_pricing_creator_cta;

/** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */
const ar_pricing_creator_cta = en_pricing_creator_cta;

/** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */
const it_pricing_creator_cta = en_pricing_creator_cta;

/** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */
const ru_pricing_creator_cta = en_pricing_creator_cta;

/** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */
const pt_pricing_creator_cta = en_pricing_creator_cta;

/** @type {(inputs: Pricing_Creator_CtaInputs) => LocalizedString} */
const ko_pricing_creator_cta = en_pricing_creator_cta;

/**
* | output |
* | --- |
* | "Go Creator" |
*
* @param {Pricing_Creator_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_creator_cta = /** @type {((inputs?: Pricing_Creator_CtaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Creator_CtaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_creator_cta(inputs)
	if (locale === "es") return es_pricing_creator_cta(inputs)
	if (locale === "fr") return fr_pricing_creator_cta(inputs)
	if (locale === "de") return de_pricing_creator_cta(inputs)
	if (locale === "ja") return ja_pricing_creator_cta(inputs)
	if (locale === "zh") return zh_pricing_creator_cta(inputs)
	if (locale === "ar") return ar_pricing_creator_cta(inputs)
	if (locale === "id") return id_pricing_creator_cta(inputs)
	if (locale === "it") return it_pricing_creator_cta(inputs)
	if (locale === "ru") return ru_pricing_creator_cta(inputs)
	if (locale === "pt") return pt_pricing_creator_cta(inputs)
	return ko_pricing_creator_cta(inputs)
});